import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

import { PipesModule } from '../pipes/pipes.module';
import { OfflineDialogComponent } from './offline-dialog.component';

@NgModule({
  declarations: [OfflineDialogComponent],
  imports: [CommonModule, MatDialogModule, MatButtonModule, PipesModule],
  exports: [OfflineDialogComponent],
})
export class OfflineDialogModule {}
